import { render, staticRenderFns } from "./BeneficiaryRequests.vue?vue&type=template&id=dba1c446"
import script from "./requests.js?vue&type=script&lang=js&external"
export * from "./requests.js?vue&type=script&lang=js&external"
import style0 from "@/assets/styles/flexben.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports